import React from 'react';
import clsx from 'clsx';
import 'tslib';
import './../../../../assets/src/components/util/NoStyleButton.css.ts.vanilla-9a05fce1.css';
import './../../../../assets/src/components/util/NoStyleLink.css.ts.vanilla-7b419b33.css';
import Visible from '../../../util/Visible/Visible.js';
import { OutlineButton } from '../../../buttons/index.js';

var BrowseButton = function (_a) {
    var title = _a.title, isDropzoneCondensed = _a.isDropzoneCondensed, disabled = _a.disabled, onClick = _a.onClick, _b = _a.classes, classes = _b === void 0 ? {} : _b;
    return (React.createElement(React.Fragment, null,
        React.createElement(Visible, { when: isDropzoneCondensed },
            React.createElement("div", { "data-testid": 'dropzone-button-condensed', onClick: onClick, className: clsx('c-dropzone__button--condensed', classes.title) }, title)),
        React.createElement(Visible, { when: !isDropzoneCondensed },
            React.createElement(OutlineButton, { "data-testid": 'dropzone-button', disabled: disabled, onClick: onClick, className: classes.button }, title))));
};

export { BrowseButton as default };
//# sourceMappingURL=BrowseButton.js.map
